export default __webpack_public_path__ + "static/media/e.525c241c.svg";